<template>
    <page @click="() => batchSetData = ''">
        <module :title="id ? '编辑文章' : '添加文章'">
            <c-form ref="form">

                <c-form-item type="input" label="标题" name="name" required></c-form-item>

                <c-form-item type="editor" label="内容" name="content" required></c-form-item>

                <c-form-item type="image" label="封面图" name="img_url" file-word="图片尺寸：700X450" required></c-form-item>

                <c-form-item type="video" label="视频" name="video_url" file-word=""></c-form-item>

                <c-form-item type="radio" label="发布状态" name="state" required :options="stateOptions"></c-form-item>
            </c-form>

            <template slot="button">
                <c-button power="b_platform_rule_edit" size="m" @click="submit(2)">提交发布</c-button>
            </template>
        </module>
    </page>
</template>

<script>
    var proutes = {
        path: '/platform_rule',  //列表页在routes中的path
        name: 'm_platform_rule',  //列表页在routes中的name
        update: 'm_platform_rule.update', //列表页定义的返回刷新的方法
        url_detail:'/abstract_consultation/detail',  //获取详情的url地址
        url_update:'/abstract_consultation/update',  //编辑提交地址
        url_add:'/abstract_consultation/add',  //新增地址
    };
    var name = 'platform_rule_edit';
    export default {
        name: name,

        props: {
            id: String
        },

        data() {
            return {
                stateOptions: [
                    {value:1,name:'禁用'},
                    {value:2,name:'启用'}
                ]
            }
        },

        computed: {

        },

        watch: {
            id() {
                this.getDetail();
            },
        },

        mounted() {
            if (this.id) {
                this.getDetail();
            }
        },

        methods: {
            getDetail() {
                this.request({
                    url: proutes.url_detail,
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.$refs.form.set(data);
                    }
                });
            },

            submit(type) {
                this.$refs.form.submit({
                    url: this.id ? proutes.url_update : proutes.url_add,
                    rule: {
                        name: '请填写标题',
                        content: '请填写内容',
                        img_url: '请上传封面图',
                        state: '请选择发布状态',
                    },
                    dataFormatter: data => {
                        // 提交前处理数据格式
                        if( this.id ){
                            data.id = this.id;
                        }
                        //固定写死，内置的类型，请勿修改
                        data.type_id=-2;
                        return data;
                    },
                    success: () => {
                        this.$message({
                            text: '保存成功'
                        });

                        this.$bus.$emit(proutes.update);
                        this.redirectTo(proutes.path);
                    }
                });
            }
        }
    }
</script>

<style lang="stylus" scoped>
  .box {
    background: #F9F8FB;
  }

  .params {
    box-sizing: border-box;
    width: 1000px;
    padding: 25px 20px 25px 45px;
  }

  .detail {
    padding: 15px;

    &-preview {
      width: 370px;
      border: 1px solid #ddd;
      margin-right: 30px;
      background: #fff;

      dt {
        border-bottom: 1px solid #ddd;
        line-height: 40px;
        font-size: 13px;
        font-weight: bold;
        text-indent: 12px;
      }

      dd {
        height: 560px;
        overflow: auto;
        font-size: 0;

        img {
          width: 100%;
          max-height: initial;
        }
      }
    }

    &-edit {
      .tips {
        line-height: 40px;
        font-size: 12px;
        color: #666;

        b {
          font-weight: bold;
          color: #f00;
        }
      }
    }
  }

  .spec {
    position: relative;
    padding: 15px 17px;
    margin-bottom: 16px;

    &-list {
      box-sizing: border-box;
      width: 1000px;
      border: 1px dotted #ddd;
      padding: 14px;
    }

    &-label {
      margin-right: 8px;
      line-height: 36px;
      font-size: 13px;
      white-space: nowrap;
      color: #444;
    }

    &-remove {
      position: absolute;
      right: 0;
      top: 0;
      width: 24px;
      line-height: 24px;
      font-size: 12px;
      text-align: center;
      color: #fff;
      background: #aaa;

      &:hover {
        background: #999;
      }
    }

    &-name {
      width: 130px;
      height: 34px;
      border: 1px solid #ddd;
      padding: 0 10px;
      margin-right: 14px;
      font-size: 13px;
      background: #fff;
    }

    .c-checkbox {
      margin-top: 0;
    }

    &-item {
      width: 128px;
      height: 30px;
      border: 1px solid #ddd;
      padding: 0 5px;
      margin-top: 12px;
      margin-right: 12px;
      background: #fff;

      &-img {
        margin-right: 5px;
        width: 25px;
        height: 25px;
        color: #bbb;
        background: #F5F5F5;
        cursor: pointer;
      }

      &-value {
        font-size: 13px;
      }

      &-remove {
        margin-left: 5px;
        font-size: 16px;
        color: #C70000;
      }
    }

    .c-button {
      margin-top: 12px;
    }
  }

  .sku-detail {
    position: relative;

    .batch-set {
      position: absolute;
      left: 0;
      top: -90px;
      padding: 0 11px 17px;
      background: #fff;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, .2);

      p {
        line-height: 43px;
        font-size: 13px;
        font-weight: bold;
      }

      input {
        width: 100px;
        height: 28px;
        border: 1px solid #ddd;
        padding: 0 5px;
        margin-right: 5px;
      }
    }

    table {
      width: 1000px;

      thead {
        background: #F9F9F9;
      }

      tbody {
        background: #fff;
      }

      th, td {
        width: 100px;
        height: 40px;
        line-height: 40px;
        border: 1px solid #ddd;
        color: #444;
        font-size: 12px;
        text-align: left;
        padding: 0 10px;
      }

      th {
        b {
          margin-right: 5px;
          color: #f00;
        }

        a {
          margin-left: 5px;
        }
      }

      td {
        input {
          width: 100%;
          height: 100%;
          border: none;
        }

        .image {
          position: relative;
          width: 28px;
          height: 28px;
          border: 1px dotted #ccc;
          font-size: 12px;
          color: #ccc;
          cursor: pointer;

          &:hover {
            border-color: #999;
            color: #999;

            a {
              display: block;
            }
          }

          a {
            display: none;
            position: absolute;
            left: 0;
            right: 0;
            line-height: 28px;
            text-align: center;
            color: #fff;
            background: rgba(0, 0, 0, .7);
          }
        }
      }
    }
  }
</style>
